import React from 'react';
import { Button, Typography } from '@pw-tech/omni-ui';
import { X } from 'lucide-react';
import Image from 'next/image';
import DialogModal from '@/modules/common/components/Modal/DialogModal';
type PaymentModalType = 'success' | 'failed';
interface PaymentStatusModalProps {
  isOpen: boolean;
  type: PaymentModalType | null;
  onClose: () => void;
  onContinue?: () => void;
  showUenNumber?: boolean;
  uenNumber?: string;
}
const PaymentStatusModal: React.FC<PaymentStatusModalProps> = ({
  isOpen,
  type,
  onClose,
  onContinue,
  showUenNumber = false,
  uenNumber = ''
}) => {
  const getModalContent = () => {
    switch (type) {
      case 'success':
        return {
          icon: <Image src="/images/registerPage/payment-success.gif" alt="success-gif" width={100} height={100} />,
          title: 'Payment Successful!',
          message: 'A payment receipt has been sent to your registered email address. Please check your inbox.',
          buttonText: 'Continue'
        };
      case 'failed':
        return {
          icon: <X size={60} color="white" className="rounded-full bg-[#E13B36] p-1" />,
          title: 'Payment Failed!',
          message: "We couldn't process your payment at this time. Please retry again with different payment method.",
          buttonText: 'Continue'
        };
      default:
        return null;
    }
  };
  const content = getModalContent();
  if (!content) return null;
  const handleContinue = () => {
    if (onContinue) {
      onContinue();
    } else {
      onClose();
    }
  };
  return <DialogModal isOpen={isOpen} title="" onClose={onClose} onSubmit={() => null} showHeader={false} showSeparator={false} showFooter={false} showCancelButton={false} showSubmitButton={false} closeOnOutsideClick={false} showCloseIcon={false} size="extra-small" data-sentry-element="DialogModal" data-sentry-component="PaymentStatusModal" data-sentry-source-file="PaymentStatusModal.tsx">
      <div className="flex flex-col items-center gap-4">
        <div>{content.icon}</div>
        <div className="flex flex-col items-center gap-1 text-center">
          <Typography variant="heading3" weight="semi-bold" data-sentry-element="Typography" data-sentry-source-file="PaymentStatusModal.tsx">
            {content.title}
          </Typography>
          <Typography variant="regular" className="!text-[#3D3D3D]" data-sentry-element="Typography" data-sentry-source-file="PaymentStatusModal.tsx">
            {content.message}
          </Typography>
          {showUenNumber ? <Typography variant="regular" className="!text-[#3D3D3D] bg-[#F8F8F8] px-1 py-[2px] rounded-lg">
              Your Unique Enrollment Number (UEN):{' '}
              <span className="font-semibold">{uenNumber}</span>
            </Typography> : <></>}
        </div>
        <Button variant="primary" onClick={handleContinue} data-sentry-element="Button" data-sentry-source-file="PaymentStatusModal.tsx">
          {content.buttonText}
        </Button>
      </div>
    </DialogModal>;
};
export default PaymentStatusModal;